import activeportal from "../../../../assets/images/docs/portal/active.png";
import tabsession from "../../../../assets/images/blogs/pp14/tabsession.png";
import screenshotoverview from "../../../../assets/images/docs/screenshot-overview.png";
import * as React from 'react';
export default {
  activeportal,
  tabsession,
  screenshotoverview,
  React
};